import { Form } from "@/components/ui/form"
import { SelectItem } from "@/components/ui/select"
import { SectionCard } from "@/components/ui/section-card"
import {
  FormTextField,
  FormSelectField,
  FormDateField,
  FormCurrencyField,
  FormFileField,
} from "@/components/form"
import {
  PAYMENT_METHOD_OPTIONS,
  HAS_COPYRIGHT_OPTIONS,
} from "../../constants/contrato.constants"
import type { ContractFormProps } from "../../contrato.types"
import { useEffect } from "react"

export function ContractForm({
  mode,
  form,
  onSubmit,
  equipe,
  handleFileUpload,
  handleMemberChange,
}: ContractFormProps) {
  const uploadedContractUrl = form.watch("uploaded_contract_url")

  return (
    <SectionCard className="bg-[#15203c] rounded-2xl p-7">
      <div className="flex flex-col gap-1 mb-6">
        <h2 className="font-bold text-[24px] text-white">
          {mode === "add" ? "Novo Contrato" : "Editar Contrato"}
        </h2>
        <p className="font-normal text-[14px] text-[#d1d1d1]">
          {mode === "add" ? "Adicionar novo contrato ao projeto" : "Editar contrato do projeto"}
        </p>
      </div>

      <Form {...form}>
        <form
          onSubmit={form.handleSubmit(onSubmit)}
          className="flex flex-col gap-6"
        >
          {/* Campos ocultos para validação — preenchidos via select de pessoa */}
          <input type="hidden" {...form.register("email")} />
          <input type="hidden" {...form.register("name")} />
          <input type="hidden" {...form.register("document")} />
          <input type="hidden" {...form.register("movieId", { valueAsNumber: true })} />

          <FormSelectField
            name="personId"
            label="Pessoa/Empresa"
            placeholder="Selecione a pessoa ou empresa"
            onChange={handleMemberChange}
            required
          >
            {(!equipe || equipe.length === 0) && (
              <SelectItem value="-" disabled>
                Nenhuma pessoa encontrada
              </SelectItem>
            )}
            {equipe?.map((p) => (
              <SelectItem key={p?.id} value={p?.id?.toString() ?? ""}>
                {p?.name}
              </SelectItem>
            ))}
          </FormSelectField>

          <FormFileField
            name="uploaded_contract_url"
            label="Documento do Contrato"
            placeholder="📄 Faça upload do PDF"
            onFileSelect={handleFileUpload}
            existingUrl={uploadedContractUrl}
            className="md:col-span-2"
          />
          <FormCurrencyField
            name="total_amount"
            label="Valor Total"
            required
          />
          <FormSelectField
            name="payment_method"
            label="Forma de Pagamento"
            placeholder="Selecione"
          >
            {PAYMENT_METHOD_OPTIONS.map((opt) => (
              <SelectItem key={opt.value} value={opt.value}>
                {opt.label}
              </SelectItem>
            ))}
          </FormSelectField>
          <FormDateField name="contract_start" label="Data de Início" />
          <FormDateField name="contract_till" label="Data de Fim" required />
          <FormDateField
            name="signature_date"
            label="Data de Assinatura do Contrato"
          />
          <FormTextField
            name="location"
            label="Local"
            placeholder="Digite aqui"
          />

          <FormSelectField
            name="has_copyright"
            label="Possui direitos autorais no contrato?"
            placeholder="Selecione"
          >
            {HAS_COPYRIGHT_OPTIONS.map((opt) => (
              <SelectItem key={opt.value} value={opt.value}>
                {opt.label}
              </SelectItem>
            ))}
          </FormSelectField>
        </form>
      </Form>
    </SectionCard>
  )
}
